export type ID = string | number | null;
export type booleanFn = (val: boolean) => boolean;

export enum UsageType {
	DOMESTIC = "DOMESTIC",
	ROAMING = "ROAMING",
}

export enum UsageEvent {
	CALLS = "CALLS",
	SMS = "SMS",
	DATA = "DATA",
}
